// config.js — leaf configuration module (no imports → no cycles, no races).
//
// Same shape and the same reason as mono-layout-3's config.js: auth.js runs
// before React mounts anything, so the API base has to be importable directly
// rather than injected at provider-mount time.

// No production fallback (corrected 2026-09-17). This line used to end with a
// hardcoded production host, which is now a tunnel to a laptop answering 502 —
// so an unset variable stopped meaning "keep working" and started meaning
// "load, render, and fail every call", with nothing on screen saying why.
//
// A production build without VITE_API_BASE is refused by vite.config.js, which
// is the only part of this app the build executes. The default below is for
// `vite dev` only: 127.0.0.1:8000 is what docker-compose publishes.
const DEV_FALLBACK = 'http://127.0.0.1:8000';

const RAW_BASE = import.meta.env.VITE_API_BASE || DEV_FALLBACK;

/** No trailing slash, ever — every call site builds `${API_BASE}/path`. */
export const API_BASE = RAW_BASE.replace(/\/+$/, '');

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

/** Shown in the account sheet so "which backend am I on?" is never a guess —
 *  the single most useful thing to see when supporting from a phone. */
export const BUILD_INFO = {
  mode: import.meta.env.MODE,
  apiBase: API_BASE,
};
